import React from 'react';
import { IconCalendar } from '../../ui-kit/icons';

const GroupScheduleButton = props => (
  <a
    key={props.station.id}
    href={`/groups/${props.station.id}/schedule/group_schedule?start_time=${props.startTime}&end_time=${props.endTime}`}
    className="absence-request-rota-link btn btn-default btn-outline-secondary btn-sm"
    target="_blank"
    rel="noreferrer"
  >
    <IconCalendar /> {props.station.name}
  </a>
);

export default GroupScheduleButton;
